import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button } from './button';
import { Download } from 'lucide-react';

interface ExportExcelProps {
  data: any[];
  columns: { label: string; key: string }[];
  filename?: string;
}

export const ExportExcel: React.FC<ExportExcelProps> = ({ data, columns, filename = 'export.xlsx' }) => {
  const handleExport = () => {
    // Map data to only include the columns specified
    const exportData = data.map(row => {
      const filtered: any = {};
      columns.forEach(col => {
        filtered[col.label] = row[col.key];
      });
      return filtered;
    });
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, filename);
  };

  return (
    <Button onClick={handleExport} variant="default">
      <Download className="mr-2 h-4 w-4" />
      Export
    </Button>
  );
}; 